import { inflateFromRight } from "../../components/Animations"
import { animated, useSpring } from "react-spring"
import React from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { TitleHeader } from "../../components/TitleHeader"
import useDeviceType from "../../utils/useDeviceType"
import { useTranslation } from "react-i18next"
import EstimatedOfferPriceHeader from "../Finances/EstimatedOfferPriceHeader"
import { useSelector } from "react-redux"
import clsx from "clsx"
import MortgageForm from "./MortgageForm"
import EstimatedHomeEquity from "./EstimatedHomeEquity"


const MortgageDisclaimer = ({ }) => {
    return <div className="bg-accumin-functional-pastel-orange card px-4 py-5 w-full flex flex-col">
        <span className="text-sm">Legal text to explain the estimated bla bla bla...
            <NavLink className="ml-1 text-accumin-primary-electric-blue underline" to="terms">[See more details]</NavLink>
        </span>
    </div>
}

const Equity = () => {
    const pageStyle = useSpring(inflateFromRight)
    const navigate = useNavigate()
    const { isMobileView } = useDeviceType()
    const { t } = useTranslation()
    const {
        valuations,
        currentValuation,
        currentMortgage,
    } = useSelector((store) => store.valuationsDetails)

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            {isMobileView && (
                <TitleHeader
                    title={t("finances.equity-title")}
                    subtitle={""}
                    hasAvatar={false}
                    handleBack={handleGoBack}
                />
            )}
            <animated.div
                className={clsx(isMobileView ? "app-container" : "desktop-container")}
                style={isMobileView ? pageStyle : {}}

            >
                <div className="flex flex-col gap-4">
                    <div className="bg-accumin-neutral-100 card px-4 py-5 w-full">
                        <EstimatedOfferPriceHeader valuation={valuations[currentValuation]?.valuation} />
                    </div>

                    <MortgageForm />
                    {currentMortgage?.id
                        ? <div className="flex flex-col gap-4">
                            <EstimatedHomeEquity />
                        </div>
                        : ''}
                    <MortgageDisclaimer />
                </div>
            </animated.div>
        </>
    )
}

export default Equity
